import React from "react";
import { useFormContext } from "react-hook-form";

import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";

import style from "../AddVaccineForm.module.css";

export const SelectField = ({
  name,
  label,
  options,
  placeholder = "Select",
  disabled = false,
  onChange,
  value,
  required = false,
  ariaRequired = false,
}) => {
  const { watch, setValue, trigger } = useFormContext();
  const controlledValue = value !== undefined ? value : watch(name);

  const handleChange = (rawValue) => {
    if (onChange) {
      onChange(rawValue);
      void trigger(name);
    } else {
      setValue(name, rawValue, { shouldValidate: true, shouldDirty: true });
    }
  };

  return (
    <FormField name={name}>
      <label className={style.pregnancyFormLabel}>
        {label}
        {required ? " *" : ""}
      </label>
      <Select
        name={name}
        options={options}
        placeholder={placeholder}
        value={controlledValue || ""}
        onChange={handleChange}
        disabled={disabled}
        fullWidth
        ariaRequired={required || ariaRequired}
      />
    </FormField>
  );
};
